import React from "react";
import {schemaMatches} from "@jsonforms/core";
import {withJsonFormsControlProps} from "@jsonforms/react";
import {Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import HierarchicalSelect from "../../hierarchical-select";
import {RENDERER_TYPES} from "../constants";

export const HierarchicalSelectTester = schemaMatches(schema => schema.renderer === RENDERER_TYPES.hierarchicalSelect);

export const HierarchicalSelectRenderer = withJsonFormsControlProps(
  ({data, handleChange, path, label, schema, errors}) => {
    const {t} = useTranslation();

    return (
      <>
        {label && <Typography sx={{margin: "8px 16px 4px"}}>{label}</Typography>}
        <HierarchicalSelect
          items={schema?.elements ?? []}
          idKey="__Guid"
          labelKey="title"
          parentKey="parent"
          value={data}
          onChange={newValue => handleChange(path, newValue)}
          levelLabel={t("components.customJsonForms.hierarchicalRenderer.levelLabel")}
          error={!!errors}
          helperText={errors}
          className="custom-json-forms__renderers__hierarchical-select"
        />
      </>
    );
  }
);
